// extracted by mini-css-extract-plugin
export default {"label":"AuthInput_label__YaDVB","input":"AuthInput_input__akSu-","isInvalid":"AuthInput_isInvalid__1h17q","errorMessage":"AuthInput_errorMessage__nPX3d"};